"use client";

import {
	ArrowDownRight,
	ArrowUpRight,
	TrendingUp,
	Zap,
	Award,
	Flame,
} from "lucide-react";

import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from "@/lib/components/card";

interface KPICardsProps {
	totalRequests: number;
	mostPopularModel: string;
	mostPopularProvider?: string;
	trendingModel: string;
	trendingGrowth?: number;
	topApp: string;
}

function KPICard({
	title,
	value,
	subtext,
	trend,
	icon,
}: {
	title: string;
	value: string | number;
	subtext?: string;
	trend?: "up" | "down";
	icon: React.ReactNode;
}) {
	return (
		<Card className="transition-all duration-150 hover:shadow-sm">
			<CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
				<CardTitle className="text-sm font-medium text-muted-foreground">
					{title}
				</CardTitle>
				<div className="text-muted-foreground">{icon}</div>
			</CardHeader>
			<CardContent>
				<div className="text-2xl font-semibold tracking-tight">{value}</div>
				{subtext && (
					<div className="mt-1 flex items-center gap-1 text-xs text-muted-foreground">
						{trend === "up" ? (
							<ArrowUpRight className="h-3 w-3 text-status-ok-icon" />
						) : trend === "down" ? (
							<ArrowDownRight className="h-3 w-3 text-status-error-icon" />
						) : null}
						{subtext}
					</div>
				)}
			</CardContent>
		</Card>
	);
}

export function KPICards({
	totalRequests,
	mostPopularModel,
	mostPopularProvider,
	trendingModel,
	trendingGrowth,
	topApp,
}: KPICardsProps) {
	return (
		<div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
			<KPICard
				title="Total Requests (30d)"
				value={totalRequests.toLocaleString()}
				icon={<Zap className="h-4 w-4" />}
			/>
			<KPICard
				title="Most Popular"
				value={mostPopularModel}
				subtext={mostPopularProvider ? `by ${mostPopularProvider}` : undefined}
				icon={<Award className="h-4 w-4" />}
			/>
			<KPICard
				title="Trending Model"
				value={trendingModel}
				subtext={trendingGrowth ? `↑ ${trendingGrowth}% this week` : undefined}
				trend={
					trendingGrowth ? (trendingGrowth > 0 ? "up" : "down") : undefined
				}
				icon={<Flame className="h-4 w-4" />}
			/>
			<KPICard
				title="Top App Using Models"
				value={topApp}
				icon={<TrendingUp className="h-4 w-4" />}
			/>
		</div>
	);
}
